import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BackArrowIcon from '../../../assets/svg/BackArrowIcon';
import { PlusIcon } from '../../../assets/svg/PlusIcon';
import { SlidingMenu } from '../../../components/SlidingMenu';
import { StyledFooterButton } from '../../../components/StyledFooterButton';
import * as routing from '../../../constants/Routing';
import { intl } from '../../../helpers/IntGlobalProvider';
import { Text } from '../../../react-components/Text';
import { usePermissions } from '../hooks/usePermissions';
import { RouteFooterContainer } from '../route/stops/route-stops-footers/RouteFooterContainer';
import { useRetrieveRoutes } from './hooks/useRetrieveRoutes';
import { useRetrieveWeatherForecast } from './hooks/useRetrieveWeatherForecast';
import { RouteCreation } from './route-creation/RouteCreation';
import { RoutesInfiniteLoader } from './RoutesInfiniteLoader';

const PREVIOUS_ROUTES_PAGINATION_LIMIT = 10;

export const RoutesListContent = () => {
  const navigate = useNavigate();

  const { canCreateRoutes } = usePermissions();

  const { data: weatherForecast } = useRetrieveWeatherForecast();

  const [isRouteCreationOpen, setIsRouteCreationOpen] = useState<boolean>(false);

  const {
    data: routes,
    hasMoreRoutes,
    isLoading,
    run: searchMoreRoutes,
    refetch: refetchRoutes,
  } = useRetrieveRoutes({
    limit: PREVIOUS_ROUTES_PAGINATION_LIMIT,
  });

  const loadMorePreviousRoutes = () => {
    searchMoreRoutes();
  };

  return (
    <SlidingMenu
      id="calendar-routes-list"
      direction="left"
      timeout={{ enter: 0 }}
      isOpen
      headerContent={
        <>
          <BackArrowIcon
            style={{
              color: RoutalPalette.white,
              height: `28px`,
              width: `28px`,
              fontSize: `25px`,
              cursor: `pointer`,
            }}
            onClick={() => navigate(routing.PRIVATE_ROUTES.ROOT)}
          />
          <Grid item style={{ width: `100%`, marginRight: `28px` }}>
            <Text
              variant="h6"
              isBold
              intlId="vehicle_drivers.list.title"
              style={{
                color: RoutalPalette.neutral02,
                textAlign: `center`,
              }}
            />
          </Grid>
        </>
      }
      hideCross
      headerStyles={{
        color: RoutalPalette.white,
        height: `70px`,
        backgroundColor: RoutalPalette.primary00,
      }}
      footerContent={
        canCreateRoutes ? (
          <>
            <RouteFooterContainer style={{ position: `inherit`, padding: `20px`, height: `auto`, zIndex: 1002 }}>
              <StyledFooterButton
                id="create-new-route-button"
                style={{ margin: `0` }}
                onClick={() => {
                  setIsRouteCreationOpen(true);
                }}
              >
                <PlusIcon color={RoutalPalette.white} />
                <HSpacer small />
                {intl.formatMessage({ id: `drivers.route.create_new` })}
              </StyledFooterButton>
            </RouteFooterContainer>
            <RouteCreation
              isOpen={isRouteCreationOpen}
              source={`Route list`}
              onClose={() => {
                setIsRouteCreationOpen(false);
              }}
            />
          </>
        ) : undefined
      }
      onClose={() => navigate(routing.PRIVATE_ROUTES.ROOT)}
      childrenStyles={{
        padding: `0`,
        overflowY: `auto`,
        backgroundColor: RoutalPalette.white,
      }}
    >
      <Grid container direction="column" flex="1" wrap="nowrap">
        <RoutesInfiniteLoader
          weatherForecast={weatherForecast}
          routes={routes ?? []}
          isLoading={isLoading}
          hasMoreRoutes={hasMoreRoutes}
          loadNextPage={() => loadMorePreviousRoutes()}
          refreshList={refetchRoutes}
        />
      </Grid>
    </SlidingMenu>
  );
};
